
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/characters/[slug]",
      function () {
        return require("private-next-pages/characters/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/characters/[slug]"])
      });
    }
  